// services/visitorCountry.js
//
// The visitor's country, for defaults they can change: the currency on the
// upgrade page, the country code beside a phone number.
//
// From Cloudflare (functions/api/geo.js), falling back to the browser's
// language region, then India. Asked once per page load and shared by every
// caller.

let networkPromise = null;
let countryPromise = null;

/**
 * Where the visitor is, as Cloudflare sees it; null when it cannot say (the
 * dev server, a network error). The one to RECORD - detectCountry's
 * fallbacks are guesses, fine for a default but not for data.
 *
 * @returns {Promise<string|null>} ISO 3166 alpha-2, e.g. 'US'
 */
export function networkCountry() {
  if (!networkPromise) {
    networkPromise = fetch('/api/geo')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => (d && /^[A-Z]{2}$/.test(d.country) ? d.country : null))
      .catch(() => null);
  }
  return networkPromise;
}

/** @returns {Promise<string>} ISO 3166 alpha-2, e.g. 'US' - always an answer */
export function detectCountry() {
  if (!countryPromise) {
    countryPromise = networkCountry().then((c) => {
      if (c) return c;
      const region = (navigator.language || '').split('-')[1];
      return region && /^[A-Za-z]{2}$/.test(region) ? region.toUpperCase() : 'IN';
    });
  }
  return countryPromise;
}

/** 'IN' -> 'India': users.country holds names, as the app's picker writes them. */
export function countryName(iso2) {
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(iso2) || null;
  } catch {
    return null;
  }
}
